(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snal-product-guide"]) return;
  try {
    
function organizeSnalDetails(root) {
  if (root.dataset.organized) return;
  root.dataset.organized = 'true';
  root.querySelectorAll('p').forEach(paragraph => {
    const list = paragraph.nextElementSibling;
    const label = paragraph.textContent.trim();
    if (!list || !['UL', 'OL'].includes(list.tagName) || !label || label.length > 100 || paragraph.closest('li, table')) return;
    const card = document.createElement('section');
    card.className = 'snal-spec-card';
    const heading = document.createElement('h3');
    heading.append(...paragraph.childNodes);
    paragraph.before(card);
    card.append(heading, list);
    paragraph.remove();
  });
  root.querySelectorAll('.snal-spec-card').forEach(card => {
    if (card.parentElement.classList.contains('snal-spec-grid')) return;
    const grid = document.createElement('div');
    grid.className = 'snal-spec-grid';
    card.before(grid);
    grid.append(card);
    while (grid.nextElementSibling?.classList.contains('snal-spec-card')) grid.append(grid.nextElementSibling);
  });
}
function initializeSnalDetails() { document.querySelectorAll('.snal-product-description').forEach(organizeSnalDetails); }
initializeSnalDetails();
document.addEventListener('shopify:section:load', initializeSnalDetails);

  } catch(e) { console.error(e); }
})();
})();
